// extracted by mini-css-extract-plugin
module.exports = {"minorIcon":"traitMinorIcon_minorIcon__2soIc traitIcon_icon__27g_e"};